import { AuditoriaCaixaComponent } from "./../auditoria-caixa/auditoria-caixa.component";
import { element } from "protractor";
import { ExibirConteudoCaixaComponent } from "./../exibir-conteudo-caixa/exibir-conteudo-caixa.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogConfirmComponent } from "./../../dialog/dialog-confirm/dialog-confirm.component";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { FormControl, FormGroup, FormBuilder } from "@angular/forms";
import { ClienteModel } from "app/model/cliente/cliente.model";
import { ClienteService } from "app/service/cliente/cliente.service";
import { MatTableDataSource, MatPaginator, MatSort } from "@angular/material";
import { CaixaService } from "./../../../service/caixa/caixa.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "@alfresco/adf-core";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import * as CryptoJS from "crypto-js";
import * as JSPM from "jsprintmanager";

@Component({
  selector: "app-listar-caixa",
  templateUrl: "./listar-caixa.component.html",
  styleUrls: ["./listar-caixa.component.scss"],
})
export class ListarCaixaComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  caixas: any[] = [];
  idCaixas: any[] = [];
  displayedColumns = [
    "select",
    "rgCaixa",
    "numeroCaixa",
    "areaCodigo",
    "descricaoArea",
    "codAlternativo",
    "descricaoTipoCaixa",
    "descricaoConteudoCaixa",
    "statusCaixa",
    "idDoObjetoCaixa",
    "qtdItens",
    "alocacao",
    "acoes",
  ];
  dataSource = new MatTableDataSource<any[]>([]);
  public clientes: ClienteModel[];
  queryField = new FormControl();
  public inputPesquisa = false;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public loading = false;
  idCaixa;
  clientePesquisado;
  buttonRelatorio = true;
  selects: FormGroup;
  adm = false;
  acervo = true;
  solicitacao = false;
  printers: string[];
  selectedPrinter: any;
  isDefaultPrinterSelected = false;
  etiquetas;
  etiquetasFormat;
  nomeClienteSelecionado;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private fb: FormBuilder,
    private caixaService: CaixaService,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {
    iconRegistry.addSvgIcon(
      "addItens",
      sanitizer.bypassSecurityTrustResourceUrl(
        "../../../../assets/images/file-earmark-diff.svg"
      )
    );
    this.selects = fb.group({
      id: [""],
    });
  }

  ngOnInit() {
    this.listarClientesUsuario();

    // WebSocket settings
    /*
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    JSPM.JSPrintManager.WS.onStatusChanged = () => {
      if (this.jspmWSStatus()) {
        // get client installed printers
        JSPM.JSPrintManager.getPrinters().then((myPrinters: string[]) => {
          this.printers = myPrinters;
          this.printers.map((element) => {
            if (element === "Microsoft XPS Document Writer") {
              this.selectedPrinter = element;
            }
          });
          console.log(this.printers);
          // this.selectedPrinter = this.printers[0];
        });
      }
    };
    */
  }

  onChange() {
    let value = (<HTMLSelectElement>document.getElementById("selectCliente"))
      .value;
  }

  selectCliente(e) {
    console.log(e);
  }

  onSearch() {
    let selectedNumber = (<HTMLSelectElement>(
      document.getElementById("selectCliente")
    )).options.selectedIndex;
    this.nomeClienteSelecionado = (<HTMLSelectElement>(
      document.getElementById("selectCliente")
    )).options[selectedNumber].innerText;
    let value = (<HTMLSelectElement>document.getElementById("selectCliente"))
      .value;
    this.clientePesquisado = parseInt(value);
    if (parseInt(value) == 0) {
      this.openSnackBarError("Nenhum Cliente selecionado !");
      return null;
    }
    this.getCaixas(parseInt(value));
  }

  nameEmpresa(name) {
    console.log(name);
  }

  checkIndividual(checked, idCaixa) {
    if (checked === true) {
      this.idCaixas.push(idCaixa);
    } else {
      let index = this.idCaixas.indexOf(idCaixa);
      this.idCaixas.splice(index, 1);
    }
    if (this.idCaixas.length > 0) {
      this.buttonRelatorio = false;
    } else {
      this.buttonRelatorio = true;
    }
  }

  checkAll(e) {
    var pageIndex = this.paginator.pageIndex;
    var pageSize = this.paginator.pageSize;
    var lengthData = this.paginator.length;
    if (e === true) {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSource.data[i]["isSelected"] = true;
        this.idCaixas.push(this.dataSource.data[i]["id"]);
        this.buttonRelatorio = false;
      }
    } else {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSource.data[i]["isSelected"] = false;
        var id = this.dataSource.data[i]["id"];
        let index = this.idCaixas.indexOf(id);
        this.idCaixas.splice(index, 1);
        this.buttonRelatorio = true;
      }
    }
  }

  relatorioCaixas() {
    if (this.idCaixas.length === 0) {
      this.openSnackBarError("Nenhuma caixa selecionada !");
    } else {
      const arrayIds = encodeURIComponent(
        CryptoJS.AES.encrypt(JSON.stringify(this.idCaixas), "pcdoc").toString()
      );
      window.open(
        `relatorio-caixas/${arrayIds}/${this.clientePesquisado}`,
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      ); // Open new window
    }
  }

  imprimirEtiquetas() {
    if (this.idCaixas.length === 0) {
      this.openSnackBarError("Nenhuma caixa selecionada !");
    } else {
      this.caixaService.downloadEtiquetas(this.idCaixas).subscribe(
        (data) => {
          this.etiquetas = data;
          // this.doPrintZPL(data);
          this.download(data);
        },
        (err) => {
          console.error(err);
          this.openSnackBarError(
            "Selecione apenas caixas com endereço definido !"
          );
        }
      );
    }
  }

  download(text) {
    var date = new Date();
    var dateFormat = date.toLocaleDateString("pt-BR");
    var nameFile = "etiquetas_rgs_" + dateFormat + ".txt";
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", nameFile);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  pesquisaAvancanda() {
    const idCliente = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(this.clientePesquisado),
        "pcdoc"
      ).toString()
    );
    this.router.navigate(["pesquisa-avancada-caixa", idCliente]);
  }

  exibirConteudos(caixaId: number) {
    const dialogRef = this.dialog.open(ExibirConteudoCaixaComponent, {
      width: "100%",
      data: { caixaId: caixaId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
    });
  }

  relatorioCaixa(caixaId) {
    const caixaIdRecebido = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(caixaId), "pcdoc").toString()
    );
    window.open(
      `relatorio-caixa/${caixaIdRecebido}`,
      "_blank",
      "location=yes,scrollbars=yes,status=yes"
    ); // Open new window
  }

  fecharCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja fechar esta caixa ? Obs: Isso impossibilitará de incluir mais itens na caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.fechaCaixaFunction(caixaId);
      }
    });
  }

  fechaCaixaFunction(idCaixa) {
    this.caixaService.fecharCaixa(idCaixa).subscribe(
      () => {
        this.openSnackBarSuccess("Caixa fechada com sucesso !");
        setTimeout(() => {
          this.getCaixas(this.clientePesquisado);
        }, 2000);
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar fechar a caixa !");
      }
    );
  }

  abrirCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja abrir esta caixa ? Obs: Isso permitirá incluir mais itens na caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.abrirCaixaFunction(caixaId);
      }
    });
  }

  abrirCaixaFunction(idCaixa) {
    this.caixaService.abrirCaixa(idCaixa).subscribe(
      () => {
        this.openSnackBarSuccess("Caixa aberta com sucesso !");
        setTimeout(() => {
          this.getCaixas(this.clientePesquisado);
        }, 2000);
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar abrir a caixa !");
        console.log(err);
      }
    );
  }

  getCaixas(idCliente: number) {
    this.loading = true;
    this.caixaService.getCaixasIdCliente(idCliente).subscribe(
      (data) => {
        this.loading = false;
        data = data.map((value) => {
          value.isSelected = false;
          return value;
        });
        if (data.length !== 0) {
          this.inputPesquisa = true;
        } else {
          this.inputPesquisa = false;
          this.openSnackBarError(`Nenhuma caixa encontrada neste Cliente !`);
        }
        this.caixas = data;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      (data) => {
        this.clientes = data.content;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  deleteCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja apagar esta caixa ? Obs: Isso apagará todos os itens da caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.apagarCaixa(caixaId);
      }
    });
  }

  editCaixa(caixaId: number) {
    this.idCaixa = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(caixaId), "pcdoc").toString()
    );
    this.router.navigate(["/editar-caixa", this.idCaixa]);
  }

  apagarCaixa(caixaId: number) {
    this.loading = true;
    console.log(caixaId);
    console.log(this.clientePesquisado);
    this.caixaService.apagarCaixa(caixaId).subscribe(
      () => {
        this.loading = false;
        this.getCaixas(this.clientePesquisado);
        this.openSnackBarSuccess("Caixa excluída com sucesso !");
      },
      (err) => {
        this.loading = false;
        this.openSnackBarError("Erro ao tentar excluír esta caixa !");
        console.error(err);
      }
    );
  }

  incluirIntens(id) {
    this.idCaixa = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(id), "pcdoc").toString()
    );
    this.router.navigate(["/incluir-conteudo", this.idCaixa]);
  }

  auditoriaCaixa(caixaId, rgCaixa) {
    const dialogRef = this.dialog.open(AuditoriaCaixaComponent, {
      width: "70%",
      data: { caixaId: caixaId, rgCaixa: rgCaixa },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  // Check JSPM WebSocket status
  jspmWSStatus() {
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
      return true;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
      //alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
      alert("JSPM has blocked this website!");
      return false;
    }
  }
  // Do Zebra ZPL printing...
  doPrintZPL(text) {
    if (this.jspmWSStatus()) {
      // Create a ClientPrintJob
      const cpj = new JSPM.ClientPrintJob();
      // Set Printer type (Refer to the help, there many of them!)
      //https://www.neodynamic.com/Products/Help/JSPrintManager4.0/articles/jsprintmanager.html#client-printer-types
      if (this.isDefaultPrinterSelected) {
        cpj.clientPrinter = new JSPM.DefaultPrinter();
      } else {
        cpj.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter);
      }

      // Set content to print...
      //Create Zebra ZPL commands for sample label
      var cmds = text;
      cpj.printerCommands = cmds;
      // Send print job to printer!
      cpj.sendToClient();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/listar-caixa/listar-caixa.component.ts